"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importStar(require("react"));
const react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
const colors_1 = require("../../../../theme/colors");
const icons_1 = require("../../../../theme/icons");
const forms_1 = require("../../../forms");
const Tooltip_styles_1 = require("./Tooltip.styles");
const Tooltip = ({ message, type, translationEditHandler, translationKey }) => {
    const InfoType = () => {
        switch (type) {
            case "error":
                return react_1.default.createElement(icons_1.Error, null);
            case "conflict":
                return react_1.default.createElement(icons_1.Warning, null);
            case "info":
                return react_1.default.createElement(icons_1.Info, { size: "small" });
            case "notification":
                return react_1.default.createElement(icons_1.Notifications, null);
            default:
                return react_1.default.createElement(icons_1.Info, { size: "small" });
        }
    };
    const [show, setShow] = (0, react_1.useState)(false);
    return (react_1.default.createElement(Tooltip_styles_1.TooltipWrapper, null,
        react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: () => {
                if (translationKey) {
                    return;
                }
                if (show) {
                    setShow(false);
                }
            } },
            react_1.default.createElement(Tooltip_styles_1.ButtonWrapper, { onClick: translationKey ? () => { } : () => setShow(!show) },
                react_1.default.createElement(Tooltip_styles_1.ButtonWrapperSpan, { onClick: translationKey ? () => setShow(!show) : () => { } },
                    react_1.default.createElement(InfoType, null)),
                react_1.default.createElement(Tooltip_styles_1.TooltipSomething, { "$show": show, className: "static-tooltip", "$inlineTranslation": !!translationKey },
                    react_1.default.createElement(Tooltip_styles_1.Label, { "$isTextCentered": true, "$inlineTranslation": !!translationKey }, translationKey ? (react_1.default.createElement(forms_1.EditableTitle, { editIconColor: colors_1.WHITE, name: message, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, translationKey), isEditable: !!translationKey })) : (message)))))));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map